import { ActionableSelectOption } from 'components/ActionableSelect/ActionableSelect';
import { Opportunity, Contract, Quote } from 'features/salesforce/salesforceTypes';
import { omit } from 'lodash';

export const parseOpportunitiesToSelectOption = (opportunities: Opportunity[]): ActionableSelectOption[] => {
  return opportunities.map(opportunity => ({
    id: opportunity.Id,
    label: opportunity.Name,
  }));
};

export const parseOpportunityToSelectOption = (opportunity?: Opportunity): ActionableSelectOption | null => {
  if (opportunity) {
    return {
      id: opportunity.Id,
      label: opportunity.Name,
    };
  }
  return null;
};

export const parseQuotesToSelectOption = (quotes: Quote[]): ActionableSelectOption[] => {
  return quotes.map(quote => ({
    id: quote.Id,
    label: quote.Name,
  }));
};

export const parseContracts = (contract: Contract) => {
  function trasnformAccount(account: { [key: string]: string | null }) {
    const transformedAccount: { [key: string]: string | null } = {};
    for (const key in account) {
      const newKey = `Account${key}`;
      transformedAccount[newKey] = account[key];
    }

    return transformedAccount;
  }
  if (contract.Account) {
    const accountObject = trasnformAccount(contract.Account);
    const rest = omit(contract, 'Account');
    return { ...rest, ...accountObject };
  }
  return contract;
};

export const parseLoansToSelectOption = (loans: { Id: string; Name: string }[]): ActionableSelectOption[] => {
  return loans.map(loan => ({
    id: loan.Id,
    label: loan.Name,
  }));
};
